import { SelectOption } from '@/components/form-components/MultiSelectCombobox'
import { RestSchemas } from '@/contexts/QueryProvider'

export type TemplateSummaryRow = RestSchemas['Messages.Templates.TTemplateActivity']

export type WorkspaceDataTemplatesFilterOptions = {
  entityTypeOptions: SelectOption<string>[]
  fileTemplateOptions: SelectOption<string>[]
  entityNameOptions: SelectOption<string>[]
}

export const normalizeValue = (value?: string | null) => value?.trim() ?? ''

export const getEntityTypeName = (row: TemplateSummaryRow) =>
  normalizeValue(row.entity?.entity_type?.name) || normalizeValue(row.file_template?.entity_type?.name)

export const getFileTemplateName = (row: TemplateSummaryRow) => normalizeValue(row.file_template?.name)

export const getEntityName = (row: TemplateSummaryRow) => normalizeValue(row.entity?.name)

export const getFileName = (row: TemplateSummaryRow) => normalizeValue(row.file_name)

export const getFileUrl = (row: TemplateSummaryRow) => normalizeValue(row.url)

export const getDateValue = (row: TemplateSummaryRow) => normalizeValue(row.date)

export const getStateValue = (row: TemplateSummaryRow) => normalizeValue(row.state)

const buildSelectOptions = (values: string[]): SelectOption<string>[] =>
  Array.from(new Set(values.filter(Boolean)))
    .sort((a, b) => a.localeCompare(b))
    .map((value) => ({ value, label: value }))

export function getWorkspaceDataTemplatesFilterOptions(
  summary: TemplateSummaryRow[]
): WorkspaceDataTemplatesFilterOptions {
  return {
    entityTypeOptions: buildSelectOptions(summary.map(getEntityTypeName)),
    fileTemplateOptions: buildSelectOptions(summary.map(getFileTemplateName)),
    entityNameOptions: buildSelectOptions(summary.map(getEntityName)),
  }
}
